import { JSX } from 'react';
import {
    BooleanField,
    CreateButton,
    Datagrid,
    DateField,
    EditButton,
    ExportButton,
    List,
    TextField,
    TopToolbar,
} from 'react-admin';

/**
 * The prices the dashboard's cost cards are worked out from.
 *
 * One row per model selector. A model with no row here is reported by the dashboard as unpriced
 * rather than as free, which is the point: a missing row and a genuinely free local model must not
 * look alike.
 */

const ListActions = () => {
    return (
        <TopToolbar>
            <CreateButton />
            <ExportButton />
        </TopToolbar>
    );
}

export const LlmModelPriceList: () => JSX.Element = (): JSX.Element => {
    return (
        <List actions={ <ListActions /> }>
            <Datagrid bulkActionButtons={ false }>
                <TextField source="modelName" label="Model selector" />
                <TextField source="label" label="Display name" />
                <TextField source="provider" />
                <TextField source="inputCostPerMillion" label="Input / 1M" />
                <TextField source="cachedInputCostPerMillion" label="Cached / 1M" />
                <TextField source="outputCostPerMillion" label="Output / 1M" />
                <BooleanField source="active" />
                <DateField source="updatedAt" />
                <EditButton />
            </Datagrid>
        </List>
    );
}
